import logError from 'utils/errorLogger'

export const getHoverText = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        text: 'A transferência foi solicitada e está aguardando confirmação'
      }
    case 'succeeded':
      return {
        text: 'A transferência foi efetuada com sucesso'
      }
    case 'canceled':
      return {
        text: 'A transferência foi cancelada e o saldo está disponível novamente'
      }
    case 'failed':
      return {
        text: 'A transferência falhou e o saldo está disponível novamente'
      }
    case 'confirmed':
      return {
        text: 'A transferência foi efetuada com sucesso'
      }
    case 'processing':
      return {
        text: 'A transferência foi solicitada e está aguardando a confirmação'
      }
    case 'under_analysis':
      return {
        text: 'A transferência está em análise e será processada após a revisão'
      }
    case 'partially_failed':
      return {
        text: 'Parte da transferência falhou e está em revisão pela nossa equipe'
      }
    default:
      logError(`Erro ao mapear o texto da tooltip de transferências: ${status}`)
      return {
        text: 'Status desconhecido'
      }
  }
}

// Transferência pendente aparece como "Processando" (mesmo label da listagem)
export const getTransferStatusLabel = (status: string) =>
  status === 'pending' || status === 'processing' ? 'Processando' : undefined
